import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { inject, observer } from "mobx-react";
import "../../../assets/css/components/Modal/Modal.css";

const VerifyOtp = inject("sharedStore")(
  observer((props) => {
    const {
      sharedStore, forgotEmail, switchModalVisibility,
      closeModalHandler, modalClass, modalVisibility } = props
    const [otp, setOtp] = useState("")
    const [forgotError, setForgotError] = useState("")

    useEffect(() => {
      Modal.setAppElement("body");
    }, [])

    const handleChange = (e) => {
      setForgotError("")
      setOtp(e.target.value)
    }

    const onFormSubmit = (e) => {
      sharedStore.showLoader();
      let data = {
        activation_key: otp,
        email: forgotEmail,
      };
      fetch("api/user/verify/email/", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }).then((json) => {
        sharedStore.hideLoader();
        if (json.error === false) {
          setOtp("")
          switchModalVisibility(null, 2, data);
        } else {
          setForgotError(json.message)
        }
      });
    }

    return (
      <Modal
        isOpen={modalVisibility}
        onRequestClose={closeModalHandler}
        className={modalClass}
        shouldCloseOnOverlayClick={false}
        contentLabel="Verify Otp Modal"
      >
        <div className="text-right">
          <span className="span-style" onClick={closeModalHandler}>
            <i className="fa fa-close" aria-hidden="true"></i>
          </span>
        </div>
        <div className="inner">
          <form>
            <label className="pull-left">Enter OTP:</label>
            <input
              type="text"
              name="otp"
              value={otp}
              onChange={handleChange}
              placeholder="Enter OTP"
              className="prompt-text mw-100"
              required
            />
            <p className="text-danger text-left mb-1">{forgotError}</p>
            <div className="row col-md-12">
              <button
                className="col-md-4 btn-blue"
                type="button"
                onClick={onFormSubmit}
              >
                <p>Verify OTP</p>
              </button>
            </div>
          </form>
        </div>
      </Modal>
    );
  }))
export default VerifyOtp;



// WEBPACK FOOTER //
// ./src/components/Authentication/VerifyOtp/VerifyOtp.jsx